import { PLP_HITS_PER_PAGE } from '~/lib/shopify/constants'
import {
  ALL_PRODUCT_METAFIELD_KEYS,
  PRODUCT_FILTERS_METAFIELD_KEYS,
} from '~/lib/shopify/metafields'

import { getShopifyProductMetafieldsList } from '~/data/product-page-data/serialize-product-metafields'

export const SHOPIFY_FILTERS_FACETS = {
  intensity: ALL_PRODUCT_METAFIELD_KEYS.INTENSITY,
  product_type: ALL_PRODUCT_METAFIELD_KEYS.PRODUCT_TYPE,
  product_page_type: ALL_PRODUCT_METAFIELD_KEYS.PAGE_TYPE,
  hide_search_recommendation:
    ALL_PRODUCT_METAFIELD_KEYS.HIDE_SEARCH_RECOMMENDATION,
  size: 'size',
  collar: PRODUCT_FILTERS_METAFIELD_KEYS.COLLAR,
  cut: PRODUCT_FILTERS_METAFIELD_KEYS.CUT,
  length: PRODUCT_FILTERS_METAFIELD_KEYS.LENGTH,
  material: PRODUCT_FILTERS_METAFIELD_KEYS.MATERIAL,
  shades_color: PRODUCT_FILTERS_METAFIELD_KEYS.SHADES,
  shape: PRODUCT_FILTERS_METAFIELD_KEYS.SHAPE,
  sleeves: PRODUCT_FILTERS_METAFIELD_KEYS.SLEEVES,
  color: PRODUCT_FILTERS_METAFIELD_KEYS.COLOR,
  style: PRODUCT_FILTERS_METAFIELD_KEYS.STYLE,
}

export const SHOPIFY_ROOT_CATEGORIES_EXCLUSIVE_FACETS = [
  SHOPIFY_FILTERS_FACETS.product_type,
  SHOPIFY_FILTERS_FACETS.color,
  SHOPIFY_FILTERS_FACETS.size,
  SHOPIFY_FILTERS_FACETS.intensity,
]

// And prepare shopify collection params
export const DEFAULT_COLLECTION_QUERY_PARAMS = {
  imagesFirst: 0,
  includeDescriptions: false,
  includeSeo: false,
  productsFirst: PLP_HITS_PER_PAGE,
  variantsFirst: 10,
  includePrices: true,
  includeProductsFilters: true,
  metafieldProductsKeys: getShopifyProductMetafieldsList('productCard'),
}
